import { Lang } from "../type/language";

export const labels: Record<Lang, Record<string, string>> = {
  fr: {
    cvEyebrow: "Commençons par ton parcours",
    cvDropTitle: "Dépose ton CV ici",
    cvDropHint: "Glisse ton fichier ou sélectionne-le sur ton appareil.",
    cvChoose: "Choisir mon CV",
    cvReplace: "Changer de fichier",
    cvFormat: "PDF uniquement · 5 Mo maximum",
    cvConsentTitle: "Préremplir mon profil avec l’IA",
    stepProgress: "Étape {current} sur {total}",
    offerFallback: "Ta candidature",

    cvTitle: "Ton CV remplit ton profil pour toi",
    cvIntro: "Dépose ton CV pour préremplir les prochaines étapes. Tu pourras vérifier et corriger les informations avant de valider.",
    cvUploadStep: "Ajoute ton CV",
    cvExtractStep: "K-SCAN extrait tes informations",
    cvReviewStep: "Vérifie ton profil prérempli",
    cvManual: "Je préfère remplir mon profil manuellement",

    cvConsent: "J’autorise K-SCAN à lire mon CV par IA pour extraire des informations complémentaires et préremplir mon profil. Je pourrai vérifier et corriger les informations préremplies.",
    cvOptional: "C’est facultatif. Tu gardes la main : les informations pourront être corrigées avant l’envoi.",
    cvReading: "Lecture du CV en cours…",
    cvAnalyze: "Préremplir avec mon CV",
    cvPrefilled: "Informations préremplies : vérifie et corrige les étapes suivantes avant de valider.",
    cvFailed: "Le préremplissage n’a pas abouti. Tu peux réessayer ou continuer manuellement.",
    cvInvalid: "Choisis un PDF de 5 Mo maximum.",

    pageTitle: "Candidature",
    missingJobId: "Il n'existe pas d'offre.",
    offer: "Offre",
    seeOffer: "Voir l'offre sur kscan.io",
    seeSite: "Voir le site kscan.io",
    language: "Langue",
    applicationSteps: "Étapes de candidature",
    stepPersonal: "Informations personnelles",
    stepProfile: "Profil",
    stepPreferences: "Préférences",
    stepTerms: "Accepter les CGU",
    stepVerifyEmail: "Vérifier l'email",
    stepConfirmApplication: "Envoyer ma candidature",
    previousStep: "Précédent",
    nextStep: "Suivant",
    firstName: "Prénom",
    lastName: "Nom",
    name: "Nom prénom",
    role: "Rôle",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    addressPlaceholder: "Adresse, ville, code postal",
    profileImage: "Image de profil",
    chooseProfileImage: "Choisir une image",
    resume: "CV",
    profileDetails: "Profil",
    schoolLevel: "Niveau d'étude",
    schoolLevelNoDegree: "Sans diplôme",
    languageKnown: "Langue",
    languageSearchPlaceholder: "Rechercher une langue",
    languageLevel: "Niveau",
    languageNative: "Langue maternelle",
    languageFluent: "Courant",
    languageIntermediate: "Intermédiaire",
    languageBasic: "Basique",
    noLanguage: "Aucune langue renseignée",
    experience: "Expérience",
    years: "ans",
    availability: "Disponibilité",
    availabilityNow: "Immédiate",
    availabilityNotice: "Préavis inférieur à 1 mois",
    availabilityNegotiable: "Préavis 1 à 3 mois",
    preferences: "Préférences",
    mobility: "Mobile",
    city: "Ville souhaitée",
    cityPlaceholder: "Paris, Lyon...",
    radius: "Rayon de mobilité (km)",
    workMode: "Mode de travail",
    workModeOnsite: "Sur site",
    workModeHybrid: "Hybride",
    workModeRemote: "Télétravail",
    "workMode.non": "Sur site",
    "workMode.hybrid": "Hybride",
    "workMode.full": "Télétravail",
    contractTypes: "Types de contrat",
    salaryMin: "Salaire minimum",
    salaryMax: "Salaire maximum",
    currency: "Devise",
    notSpecified: "Non renseigné",
    "contractType.cdi": "CDI",
    "contractType.cdd": "CDD",
    "contractType.freelance": "Freelance",
    "contractType.interim": "Intérim",
    "contractType.stage": "Stage",
    "contractType.alternant": "Alternance",
    "contractType.vie": "VIE",
    "contractType.civic_service": "Service civique",
    "contractType.help_contract": "Contrat aidé",
    "contractType.partial_time": "Temps partiel",
    accept: "J'accepte les CGU",
    submit: "Postuler",
    required: "Champ requis",
    invalidEmail: "Email invalide",
    invalidPhone: "Téléphone invalide",
    invalidResumePdf: "Le CV doit être un fichier PDF.",
    invalidProfileImage: "L'image doit être un fichier JPG, PNG ou WebP.",
    invalidProfileImageSize: "L'image ne doit pas dépasser 5 Mo.",
    invalidSalary: "Salaire invalide",
    invalidSalaryRange: "Le salaire minimum doit être inférieur au maximum.",
    invalidRadius: "Rayon invalide",
    verifyAccountTitle: "Vérifiez votre adresse email",
    verifyAccountText: "Envoyez un code de vérification à votre adresse email.",
    verifyAccountMailSent: "Veuillez cliquer sur le lien pour confirmer l'envoi de votre CV.",
    verifyAccountCodeSent: "Un code de vérification vient d'être envoyé à votre adresse email.",
    verifyAccountEnterCode: "Saisissez le code reçu pour continuer.",
    verifyAccountRequired: "Veuillez vérifier votre adresse email avant de continuer.",
    verifyAccountWaiting: "En attente de votre confirmation...",
    verifyAccountSendCodeButton: "Envoyer le code",
    verifyAccountResendButton: "Renvoyer le code",
    verifyAccountVerifyCodeButton: "Vérifier le code",
    verifyAccountCodePlaceholder: "Code",
    verifyAccountValidated: "Email confirmé",
    verifyAccountSuccess: "Email confirmé. Envoi du CV en cours.",
    verifyAccountSubmittingCv: "Envoi du CV...",
    verifyAccountExpired: "Le code de confirmation a expiré. Vous pouvez renvoyer un code.",
    verifyAccountInvalidCode: "Code invalide ou expiré",
    applicationSendingTitle: "Envoi de la candidature",
    applicationSendingText: "Votre email est confirmé. Nous envoyons votre candidature.",
    applicationConfirmedTitle: "Candidature envoyée",
    applicationConfirmedText: "Votre candidature a bien été envoyée. Vous recevrez un email si votre compte vient d'être créé.",
    thanksTitle: "CV envoyé",
    emailSent: "Si votre compte vient d'être créé, vous recevrez un email pour créer votre mot de passe.",
    exploreOffers: "Explorer les offres disponibles",
  },
  en: {
    cvEyebrow: "Let’s start with your background",
    cvDropTitle: "Drop your CV here",
    cvDropHint: "Drag your file here or select it from your device.",
    cvChoose: "Choose my CV",
    cvReplace: "Change file",
    cvFormat: "PDF only · Maximum 5 MB",
    cvConsentTitle: "Prefill my profile with AI",
    stepProgress: "Step {current} of {total}",
    offerFallback: "Your application",

    cvTitle: "Let your CV fill in your profile",
    cvIntro: "Upload your CV to prefill the next steps. You can review and correct the information before submitting.",
    cvUploadStep: "Upload your CV",
    cvExtractStep: "K-SCAN extracts your information",
    cvReviewStep: "Review your prefilled profile",
    cvManual: "I prefer to fill in my profile manually",

    cvConsent: "I authorize K-SCAN to read my CV using AI to extract additional information and prefill my profile. I can review and correct the prefilled information.",
    cvOptional: "This is optional. You stay in control: review and edit your information before submitting.",
    cvReading: "Reading your CV…",
    cvAnalyze: "Prefill from my CV",
    cvPrefilled: "Information prefilled: review and correct the next steps before submitting.",
    cvFailed: "Prefill failed. You can retry or continue manually.",
    cvInvalid: "Choose a PDF no larger than 5 MB.",

    pageTitle: "Application",
    missingJobId: "There is not offer",
    offer: "Offer",
    seeOffer: "View offer on kscan.io",
    seeSite: "Visit kscan.io",
    language: "Language",
    applicationSteps: "Application steps",
    stepPersonal: "Personal information",
    stepProfile: "Profile",
    stepPreferences: "Preferences",
    stepTerms: "Accept terms",
    stepVerifyEmail: "Verify email",
    stepConfirmApplication: "Confirm application",
    previousStep: "Previous",
    nextStep: "Next",
    firstName: "First name",
    lastName: "Last name",
    name: "Full name",
    role: "Role",
    email: "Email",
    phone: "Phone",
    address: "Address",
    addressPlaceholder: "Address, city, postal code",
    profileImage: "Profile image",
    chooseProfileImage: "Choose image",
    resume: "Resume",
    profileDetails: "Profile",
    schoolLevel: "Education level",
    schoolLevelNoDegree: "No degree",
    languageKnown: "Language",
    languageSearchPlaceholder: "Search a language",
    languageLevel: "Level",
    languageNative: "Native",
    languageFluent: "Fluent",
    languageIntermediate: "Intermediate",
    languageBasic: "Basic",
    noLanguage: "No language provided",
    experience: "Experience",
    years: "years",
    availability: "Availability",
    availabilityNow: "Immediate",
    availabilityNotice: "Notice under 1 month",
    availabilityNegotiable: "Notice 1 to 3 months",
    preferences: "Preferences",
    mobility: "Mobile",
    city: "Preferred city",
    cityPlaceholder: "Paris, London...",
    radius: "Mobility radius (km)",
    workMode: "Work mode",
    workModeOnsite: "On site",
    workModeHybrid: "Hybrid",
    workModeRemote: "Remote",
    "workMode.non": "On site",
    "workMode.hybrid": "Hybrid",
    "workMode.full": "Remote",
    contractTypes: "Contract types",
    salaryMin: "Minimum salary",
    salaryMax: "Maximum salary",
    currency: "Currency",
    notSpecified: "Not specified",
    "contractType.cdi": "Permanent",
    "contractType.cdd": "Fixed-term",
    "contractType.freelance": "Freelance",
    "contractType.interim": "Temporary",
    "contractType.stage": "Internship",
    "contractType.alternant": "Apprenticeship",
    "contractType.vie": "VIE",
    "contractType.civic_service": "Civic service",
    "contractType.help_contract": "Supported contract",
    "contractType.partial_time": "Part-time",
    accept: "I accept the Terms",
    submit: "Apply",
    required: "Required field",
    invalidEmail: "Invalid email",
    invalidPhone: "Invalid phone",
    invalidResumePdf: "The resume must be a PDF file.",
    invalidProfileImage: "The image must be a JPG, PNG or WebP file.",
    invalidProfileImageSize: "The image must be under 5 MB.",
    invalidSalary: "Invalid salary",
    invalidSalaryRange: "Minimum salary must be lower than maximum salary.",
    invalidRadius: "Invalid radius",
    verifyAccountTitle: "Verify your email address",
    verifyAccountText: "Send a verification code to your email address.",
    verifyAccountMailSent: "Please click the link to confirm your resume submission.",
    verifyAccountCodeSent: "A verification code has been sent to your email address.",
    verifyAccountEnterCode: "Enter the code you received to continue.",
    verifyAccountRequired: "Please verify your email address before continuing.",
    verifyAccountWaiting: "Waiting for your confirmation...",
    verifyAccountSendCodeButton: "Send code",
    verifyAccountResendButton: "Resend code",
    verifyAccountVerifyCodeButton: "Verify code",
    verifyAccountCodePlaceholder: "Code",
    verifyAccountValidated: "Email confirmed",
    verifyAccountSuccess: "Email confirmed. Submitting your resume.",
    verifyAccountSubmittingCv: "Submitting resume...",
    verifyAccountExpired: "The confirmation code has expired. You can resend a code.",
    verifyAccountInvalidCode: "Invalid or expired code",
    applicationSendingTitle: "Submitting application",
    applicationSendingText: "Your email is confirmed. We are submitting your application.",
    applicationConfirmedTitle: "Application sent",
    applicationConfirmedText: "Your application has been sent. You will receive an email if your account was just created.",
    thanksTitle: "Resume sent",
    emailSent: "If your account was just created, you will receive an email to create your password.",
    exploreOffers: "Explore available offers",
  },
};
